import { useCallback } from 'react';
import { usePut } from 'app/queryProvider';
import { Telemetry } from 'app/services/telemetry/Telemetry';
import { OnboardingRoutes } from '../api';
import type { TRecordTourPayload } from '../types';
import { traceTour } from '../utils';

/**
 * Records a finished tour against `users/me`. Fire-and-forget: nothing renders off
 * the result, and a failure only means the tour may replay on the next launch.
 */
export const useRecordTour = (): ((payload: TRecordTourPayload) => void) => {
  const { mutate } = usePut<TRecordTourPayload, unknown>({
    options: {
      onError: error =>
        Telemetry.error(error, {
          event: 'onboarding.tour.record.fail',
          domain: 'onboarding',
        }),
    },
  });

  return useCallback(
    (payload: TRecordTourPayload) => {
      traceTour('recording', payload);

      mutate({
        resource: { name: 'users' },
        url: OnboardingRoutes.users.recordTour(),
        data: payload,
      });
    },
    [mutate],
  );
};
